import { useContext } from 'react';
import TradeContext from '~/context/common/TradeContext';
import { TradeStatus, activeTradeStatuses, statusColorMap } from './constants';
import StatusIndicator from '../StatusIndicator';

type OwnProps = {
  tradeStatus: TradeStatus;
};

export default function Status({ tradeStatus }: OwnProps) {
  const { statusAgnosticTrade } = useContext(TradeContext);
  const { daysToExpiration } = statusAgnosticTrade ?? {};
  const daysToExpired = daysToExpiration ? daysToExpiration : 0;

  const showStatus =
    Boolean(activeTradeStatuses[tradeStatus] && daysToExpiration != null) ||
    !Boolean(activeTradeStatuses[tradeStatus]);

  const statusText = Boolean(activeTradeStatuses[tradeStatus])
    ? daysToExpired === 0
      ? 'Expires today'
      : `Expires in ${daysToExpired} days`
    : `Offer ${tradeStatus}`;

  return showStatus ? (
    <StatusIndicator
      statusColor={statusColorMap[tradeStatus]}
      text={statusText}
    />
  ) : null;
}
